import React from 'react';
import { Card, CardContent, CircularProgress, Container, Divider, Typography } from '@material-ui/core';
import ToysIcon from '@material-ui/icons/Toys';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { CgSmartHomeWashMachine } from "react-icons/cg";
import { FaFan, FaHotTub, FaSolarPanel } from "react-icons/fa";
import { GiCoffeeCup, GiRefinery, GiThermometerHot } from "react-icons/gi";
import { IoIosLocate } from "react-icons/io";
import { MdLocalLaundryService } from "react-icons/md";
import { RiBattery2ChargeFill, RiFridgeLine, RiWaterFlashLine } from "react-icons/ri";
import { SiAirplayvideo } from "react-icons/si";
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import * as Survey from 'survey-react';

export const forms = [
  { key: '1', value: 'Klima Keşif', icon: <FaFan />, iconObj: FaFan, basvuruNedeni: 'Klima-Klima Keşif' },
  { key: '2', value: 'Kombi Keşif', icon: <GiThermometerHot />, iconObj: GiThermometerHot, basvuruNedeni: 'Kombi-Kombi keşif' },
  { key: '3', value: 'Ani Su Isıtıcısı Keşif', icon: <RiWaterFlashLine />, iconObj: RiWaterFlashLine, basvuruNedeni: 'Ani Su Isıtıcısı-Keşif' },
  { key: '4', value: 'Vitroseramik - Endüksiyon Ocak Keşif', icon: <IoIosLocate />, iconObj: IoIosLocate, basvuruNedeni: 'Ocak-Keşif' },
  { key: '5', value: 'Kombi İlk Kullanım', icon: <GiThermometerHot />, iconObj: GiThermometerHot, basvuruNedeni: 'Kombi-İlk Kullanım' },
  { key: '6', value: 'Buzdolabı-SBS Keşif', icon: <RiFridgeLine />, iconObj: RiFridgeLine, basvuruNedeni: 'Buzdolabı-SBS Keşif' },
  { key: '7', value: 'DAC-Keşif', icon: <RiFridgeLine />, iconObj: RiFridgeLine, basvuruNedeni: 'DAC-Keşif' },
  { key: '8', value: 'Şofben Keşif', icon: <FaHotTub />, iconObj: FaHotTub, basvuruNedeni: 'Şofben-Şofben Keşif' },
  { key: '9', value: 'Telve Pro-Keşif', icon: <GiCoffeeCup />, iconObj: GiCoffeeCup, basvuruNedeni: 'Telve Pro-Keşif' },
  { key: '10', value: 'Videowall - DS TV - Keşif', icon: <SiAirplayvideo />, iconObj: SiAirplayvideo, basvuruNedeni: 'Videowall - DS TV - Keşif' },
  { key: '11', value: 'Solar Enerji Sistemi-Keşif', icon: <FaSolarPanel />, iconObj: FaSolarPanel, basvuruNedeni: 'Solar Enerji Sistemi-Keşif' },
  { key: '12', value: 'Tezgah Altı Su Filtrasyon Cihazı', icon: <GiRefinery />, iconObj: GiRefinery, basvuruNedeni: 'Su Filtrasyon Cihazı - Keşif' },
  { key: '13', value: 'Sebil Tipi Filtrasyon Cihazı', icon: <GiRefinery />, iconObj: GiRefinery, basvuruNedeni: 'Su Filtrasyon Cihazı - Keşif' },
  { key: '14', value: 'Bulaşık Makinesi Bakım', icon: <GiRefinery />, iconObj: GiRefinery, basvuruNedeni: 'Bulaşık Makinesi-Bakım' },
  { key: '15', value: 'Kurutmalı Çamaşır Makinesi Bakım', icon: <MdLocalLaundryService />, iconObj: MdLocalLaundryService, basvuruNedeni: 'Çamaşır Makinesi-Bakım' },
  { key: '16', value: 'Buzdolabı Bakım', icon: <RiFridgeLine />, iconObj: RiFridgeLine, basvuruNedeni: 'Buzdolabı-Bakım' },
  { key: '17', value: 'Isı Pompalı Kurutma Bakım', icon: <MdLocalLaundryService />, iconObj: MdLocalLaundryService, basvuruNedeni: 'Kurutma Makinesi-Bakım' },
  { key: '18', value: 'Kondenserli Kurutma Bakım', icon: <MdLocalLaundryService />, iconObj: MdLocalLaundryService, basvuruNedeni: 'Kurutma Makinesi-Bakım' },
  { key: '19', value: 'Ankastre Fırın Bakım', icon: <CgSmartHomeWashMachine />, iconObj: CgSmartHomeWashMachine, basvuruNedeni: 'Fırın-Bakım' },
  { key: '20', value: 'Solo Fırın Bakım', icon: <CgSmartHomeWashMachine />, iconObj: CgSmartHomeWashMachine, basvuruNedeni: 'Fırın-Bakım' },
  { key: '21', value: 'Çamaşır Makinesi Bakım', icon: <MdLocalLaundryService />, iconObj: MdLocalLaundryService, basvuruNedeni: 'Çamaşır Makinesi-Bakım' },
  { key: '22', value: 'Kombi Bakım', icon: <GiThermometerHot />, iconObj: GiThermometerHot, basvuruNedeni: 'Kombi-Bakım' },
  { key: '23', value: 'Klima Genel Bakım', icon: <FaFan />, iconObj: FaFan, basvuruNedeni: 'Klima-Bakım' },
  { key: '24', value: 'Su Sebili Bakım', icon: <RiFridgeLine />, iconObj: RiFridgeLine, basvuruNedeni: 'Su Sebili-Yıllık Bakım' },
  { key: '25', value: 'Termosifon Keşif', icon: <GiThermometerHot />, iconObj: GiThermometerHot, basvuruNedeni: 'Termosifon-Keşif' },
  { key: '28', value: 'Klima Toplu Keşif Formu', icon: <FaFan />, iconObj: FaFan, basvuruNedeni: 'Klima-Klima Keşif' },
  { key: '29', value: 'Kombi Toplu Keşif Formu', icon: <GiThermometerHot />, iconObj: GiThermometerHot, basvuruNedeni: 'Kombi-Kombi keşif' },
  { key: '30', value: 'Ankastre Beyaz Eşya Toplu Keşif Formu', icon: <IoIosLocate />, iconObj: IoIosLocate, basvuruNedeni: '-' },
  { key: '31', value: 'Aspiratör ve Davlumbaz Bakım', icon: <ToysIcon />, iconObj: ToysIcon, basvuruNedeni: 'Aspiratör-Genel Bakım//Temizlik//Kontrol' },
  { key: '32', value: 'Su Filtrasyon Cihazı-Keşif Formu', icon: <GiRefinery />, iconObj: GiRefinery, basvuruNedeni: 'Su Filtrasyon Cihazı - Keşif' },
  { key: '33', value: 'Su Filtrasyon Cihazı-Keşif Formu', icon: <GiRefinery />, iconObj: GiRefinery, basvuruNedeni: 'Su Filtrasyon Cihazı - Keşif' },
  { key: '4050', value: 'TV-Keşif', icon: <SiAirplayvideo />, iconObj: SiAirplayvideo, basvuruNedeni: 'TV-Keşif' },
  { key: '35', value: 'Elektrikli Araç Şarj İstasyonu AC-Keşif Formu', icon: <RiBattery2ChargeFill />, iconObj: RiBattery2ChargeFill, basvuruNedeni: 'Elektrikli Araç Şarj İstasyonu AC-Keşif' },
  { key: '4051', value: 'Ocak Ürün Grubu Bilgi Verme', icon: <SiAirplayvideo />, iconObj: SiAirplayvideo, basvuruNedeni: '' },
  { key: '4052', value: 'Fırın Ürün Grubu Bilgi Verme', icon: <SiAirplayvideo />, iconObj: SiAirplayvideo, basvuruNedeni: '' },
  { key: '4053', value: 'Çamaşır Ürün Grubu Bilgi Verme', icon: <SiAirplayvideo />, iconObj: SiAirplayvideo, basvuruNedeni: '' },
  { key: '4054', value: 'Buzdolabı Ürün Grubu Bilgi Verme', icon: <SiAirplayvideo />, iconObj: SiAirplayvideo, basvuruNedeni: '' },
  { key: '4055', value: 'Klima Ürün Grubu Bilgi Verme', icon: <SiAirplayvideo />, iconObj: SiAirplayvideo, basvuruNedeni: '' },
  { key: '4056', value: 'Bulaşık Ürün Grubu Bilgi Verme', icon: <SiAirplayvideo />, iconObj: SiAirplayvideo, basvuruNedeni: '' },
  { key: '4057', value: 'Kurutma Ürün Grubu Bilgi Verme', icon: <SiAirplayvideo />, iconObj: SiAirplayvideo, basvuruNedeni: '' },
  { key: '4058', value: 'TV Ürün Grubu Bilgi Verme', icon: <SiAirplayvideo />, iconObj: SiAirplayvideo, basvuruNedeni: '' },
  { key: '4059', value: 'OKC Ürün Grubu Bilgi Verme', icon: <SiAirplayvideo />, iconObj: SiAirplayvideo, basvuruNedeni: '' },
  { key: '4060', value: 'Robot Süpürge Ürün Grubu Bilgi Verme', icon: <SiAirplayvideo />, iconObj: SiAirplayvideo, basvuruNedeni: '' },
];



const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  BultenDetay: {
    marginTop: theme.spacing(1)
  },
  value: {
    fontWeight: theme.typography.fontWeightMedium
  },
  type: {
    fontWeight: theme.typography.fontWeightMedium
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  searchButton: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));


function Form(
  {
    match, className, readonly, FisNo, BasvuruNedeni
  }
) {



  const classes = useStyles();
  const [anketData, setAnketData] = useState({});
  const [formData, setFormData] = useState({});
  const [anketBitti, setAnketBitti] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mesaj, setMesaj] = useState('Form Başarıyla Tamamlandı.');
  const [FormNo, setFormNo] = useState("1");

  const handleAnketBitti = (MesajParam = "Form başarıyla kaydedildi. Smsiniz fiş kapama merkeze gönder işleminden sonra gönderilecektir...") => {
    setAnketBitti(true);
    setMesaj(MesajParam);
  };

  const GetArtemisForm = useCallback((FormId, FisNo) => {
    if (FisNo === 1) {
      return;
    }
    setLoading(true);
    if (FisNo !== undefined) {
      axios.get(`GetArtemisForm/${FormId}/${FisNo}`)
        .then((response) => {
          let res = response.data;
          if (typeof res === "string") {
            handleAnketBitti(res);
            setLoading(false);
            return;
          }
          
          // Güvenli JSON parse - undefined veya geçersiz değerlerde hata vermez
          const jsonStr = res?.[0]?.json;
          const formDataStr = res?.[0]?.FormData;
          
          if (!jsonStr || jsonStr === 'undefined' || jsonStr === 'null') {
            handleAnketBitti("Form verileri alınamadı. Lütfen tekrar deneyiniz.");
            setLoading(false);
            return;
          }
          
          let anketData = {};
          let formData = {};
          
          try {
            anketData = JSON.parse(jsonStr);
          } catch (parseError) {
            console.warn('Form JSON parse hatası:', parseError.message);
            handleAnketBitti("Form verisi okunamadı. Lütfen tekrar deneyiniz.");
            setLoading(false);
            return;
          }
          
          try {
            if (formDataStr && formDataStr !== 'undefined' && formDataStr !== 'null') {
              formData = JSON.parse(formDataStr);
            }
          } catch (parseError) {
            console.warn('FormData JSON parse hatası:', parseError.message);
            // FormData parse hatası kritik değil, boş obje kullan
            formData = {};
          }
          
          if (anketData.pages === undefined) {
            handleAnketBitti("Merkezden Form Bilgileri Alınamadı!..");
          }
          setAnketData(anketData);
          setFormData(formData);
          setLoading(false);
        })
        .catch((error) => {
          console.warn('Form yükleme hatası:', error.message);
          handleAnketBitti("Form yüklenirken bir hata oluştu. Lütfen tekrar deneyiniz.");
          setLoading(false);
        })
    }
  }, []);

  useEffect(() => {



    var FormId = forms.filter(x => x.basvuruNedeni === BasvuruNedeni)[0]?.key;


    if (FormId === undefined) {
      alert("İlgili form bulunamadı!...");
      return;
    }

    setFormNo(FormId);

    GetArtemisForm(FormId, FisNo);

  }, [match, FisNo, readonly, GetArtemisForm, BasvuruNedeni]);

  const onComplete = (survey) => {
    setLoading(true);
    const data = {
      Data: survey.data,
      FormTipi: FormNo,
      FisNo: FisNo,
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetArtemisForm', { jsonString: JSON.stringify(data) }, config)
      .then(() => {
        handleAnketBitti();
        setLoading(false);
      })
  };

  const defaultThemeColors = Survey
    .StylesManager
    .ThemeColors.default;
  defaultThemeColors['$main-color'] = '#FF9800';
  defaultThemeColors['$main-hover-color'] = '#FF9800';
  defaultThemeColors['$text-color'] = '#424242';

  Survey
    .StylesManager
    .applyTheme();
  const model = new Survey.Model(anketData);
  model.locale = 'tr';
  return (
    <Page className={classes.root}>
      <Container maxWidth="lg">
        {/* <Header headerTitle={FormTitle} FisNo={FisNo} /> */}
        <Card
          className={clsx(classes.root, className)}
        >          <Divider />
          <div className={classes.content}>
            {
              loading && <CircularProgress
                status={'loading'}
                style={{ marginLeft: '50%' }} />
            }
            {(!loading && anketBitti) && <CardContent className={classes.content}><Typography variant="h5" gutterBottom>{mesaj}</Typography></CardContent>}
            {(!loading && !anketBitti) &&
              <Survey.Survey json={anketData}
                data={formData}
                onComplete={onComplete}
                completeText="Formu Tamamla"
                emptySurvey="Uygun Form Bulunamadı." />
            }
          </div>
        </Card>
      </Container>
    </Page>
  );
}



Form.propTypes = {
  className: PropTypes.string,
  readonly: PropTypes.bool,
  match: PropTypes.object
};
export default connect(
  (state) => ({ tasks: state.tasks1 }),
)(Form);
